import isAnonymousUser from "../../utils/isAnonymousUser";
import isMaxUser from "../../utils/isMaxUser";
import {CMP, MY_PRICE} from "./PriceTypes";
import {GST_FREE, GST_INCLUSIVE, GST_EXCLUSIVE} from "./GstTypes";

const getInitialState = (userType, gstFree, pack1Uom, postCode, isInWishlist, branchId, branchName) => {
  const isPostCodeUpdateRequired = isAnonymousUser(userType) && !postCode;
  const isMaxUserType = isMaxUser(userType);
  const priceType = isMaxUserType ? MY_PRICE : CMP;
  const pricePreference = localStorage.getItem("user-price-view-preference");
  const gstSetting = pricePreference && !JSON.parse(pricePreference).showGstInclusive ? GST_EXCLUSIVE : GST_INCLUSIVE;
  const gstType = gstFree ? GST_FREE : gstSetting;
  const showUnitOfMeasure = isMaxUserType;
  const showGstToggle = isMaxUserType && !gstFree;
  const showPriceTypeToggle = isMaxUserType;
  const showStockAvailability = isMaxUserType;

  return {
    isPostCodeUpdateRequired,
    priceType,
    gstType,
    isPriceListLoading: false,
    priceListError: null,
    priceList: null,
    price: null,
    isClearancePriceLoading: false,
    oldGstInclusivePrice: null,
    gstInclusivePrice: null,
    showPriceTypeToggle,
    showGstToggle,
    cmpGstInclusivePrice: null,
    showUnitOfMeasure,
    selectedUnitOfMeasure: pack1Uom,
    quantity: 1,
    isInWishlist,
    quantityError: null,
    canAddToCart: false,
    showStockAvailability,
    isStockAvailabilityLoading: true,
    stockAvailabilityList: null,
    stockError: null,
    stockAvailability: null,
    isStockAvailabilityBranchesLoading: false,
    stockAvailabilityBranchesList: null,
    stockBranchesError: null,
    showBranchSelector: false,
    suburbsList: [],
    branchId: branchId,
    branchName: branchName
  };
};

export default getInitialState;
